var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.panelTypeList.length != 0 ? _c("div", {
    staticClass: "index-container border-box"
  }, [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.tabChange
    }
  }, _vm._l(_vm.panelTypeList, function (item) {
    return _c("a-tab-pane", {
      key: item.key,
      attrs: {
        tab: _vm.$t(item.value)
      }
    }, [_vm.isGetData ? _c("div", {
      staticClass: "loadingBox"
    }, [_c("a-icon", {
      staticStyle: {
        "font-size": "80px"
      },
      attrs: {
        type: "loading-3-quarters",
        spin: ""
      }
    }), _c("span", [_vm._v(_vm._s(_vm.$t("数据加载中")))])], 1) : _c("exhibition", {
      key: _vm.timer1,
      attrs: {
        previewList: _vm.previewList,
        queryMethod: _vm.queryMethod,
        timeFrame: _vm.timeFrame,
        dateFrame0: _vm.dateFrame0,
        dateFrame1: _vm.dateFrame1,
        dateFrame2: _vm.dateFrame2,
        dateFrame3: _vm.dateFrame3,
        dateFrame4: _vm.dateFrame4,
        dateFrame: _vm.dateFrame
      },
      on: {
        setTmeFrame: _vm.setTmeFrameFun,
        setDateFrame: _vm.setDateFrameFun,
        setDateFrameSingles: _vm.setDateFrameSinglesFun
      }
    })], 1);
  }), 1)], 1) : _c("div", [_c("div", {
    staticStyle: {
      "padding-top": "100px",
      width: "100%"
    }
  }, [_c("img", {
    staticStyle: {
      width: "70%",
      display: "block",
      margin: "0 auto"
    },
    attrs: {
      src: _vm.url,
      alt: "404"
    }
  })])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };